import React from "react";
import { Modal } from "react-bootstrap";
import "./OrderDetailsCard.css";
import { DELETE_ORDER_FROM_VEHICLE } from "../../URLs/Apis";
import axios from "axios";
import { useSelector } from "react-redux";

function DeletOrderFromVan({
  showDeleteOrder,
  setShowDeleteOrder,
  deletOrderID,
  text,
}) {
  const { user } = useSelector((state) => state.auth);
  const CloseDeleteOrderModol = () => setShowDeleteOrder(false);

  const deletTheOrderFromVan = () => {
    console.log(deletOrderID);
    const headers = {
      Authorization: "Bearer " + user?.token,
    }; // auth header with bearer token
    const dataBody = {
      _method: "DELETE",
      vehicle_id: window.location.href.split("/").at(-1),
      order_id: deletOrderID,
      comment: "AS so",
    };
    axios
      .delete(`${DELETE_ORDER_FROM_VEHICLE}`, dataBody, { headers })
      .then((response) => {
        //data message success
        setShowDeleteOrder(false);
        console.log(response);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
  return (
    <Modal show={showDeleteOrder} onHide={CloseDeleteOrderModol}>
      <Modal.Header className="DeletOrderModal_header">
        <Modal.Title className="DeletOrderModal_title">
          Confirm Deletion
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="deleteOrderMasege">{text}</div>
        <div className="OrdersTable-footer">
          <button onClick={CloseDeleteOrderModol} className="ordersCancelTable">
            Cancel
          </button>
          <button onClick={deletTheOrderFromVan} className=" deletOrderbutton ">
            Delete
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeletOrderFromVan;
